<template>
  <el-form :model="form" label-width="95px" :disabled="mode === 'view'">
    <el-form-item label="数据来源">
      <el-select
        v-model="form.dataSource"
        placeholder="请选择栏目"
        filterable
        @change="sourceChange"
      >
        <el-option
          v-for="item in columnData"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="排列方式">
      <el-select
        v-model="config.component"
        placeholder="请选择"
        filterable
        @change="layoutChange(config)"
      >
        <el-option
          v-for="item in h5NewsVideoType"
          :key="item.value"
          :label="item.name"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="图片展示">
      <el-select v-model="form.imageFit" placeholder="请选择" filterable @change="selectChange">
        <el-option
          v-for="item in imageFitType"
          :key="item.value"
          :label="item.name"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="显示名称" v-if="form.showTitle">
      <el-input
        v-model="form.title"
        placeholder="显示名称"
        @input="selectChange"
        maxlength="20"
        clearable
      />
    </el-form-item>
    <!-- <el-form-item label="显示边框圆角">
      <el-checkbox v-model="form.isBorderRadius" @change="selectChange"></el-checkbox>
    </el-form-item> -->
    <el-form-item label="显示时间">
      <el-checkbox v-model="form.showDate" @change="selectChange"></el-checkbox>
    </el-form-item>
    <el-form-item label="显示栏目名称">
      <el-checkbox v-model="form.showTitle" @change="selectChange"></el-checkbox>
    </el-form-item>
    <el-form-item label="显示更多">
      <el-checkbox v-model="form.showMore" @change="selectChange"></el-checkbox>
    </el-form-item>
    <el-form-item label="展示行数">
      <el-input-number
        v-model="form.row"
        :min="1"
        @change="selectChange"
        controls-position="right"
        class="w-full"
      />
    </el-form-item>
    <el-form-item label="每行展示条数">
      <el-input-number
        v-model="form.col"
        :min="1"
        :max="2"
        @change="selectChange"
        controls-position="right"
        class="w-full"
      />
    </el-form-item>
    <layoutConfig
      :config="config"
      :layoutWidth="layoutWidth"
      :layout="layout"
      @layoutChange="layoutChange"
    />
  </el-form>
</template>

<script>
import { ColumApi } from '@wiz-api/workbench'
import { treeToOneArray } from '@/assets/js/Common'
import layoutConfig from './LayoutConfig'
import { imageFitType } from '../../js/config'
import { h5NewsVideoType } from '../../js/appConfig'

const columnApi = new ColumApi()
export default {
  props: ['configData', 'layoutData', 'mode', 'layoutWidth', 'layout'],
  components: {
    layoutConfig,
  },
  data() {
    return {
      h5NewsVideoType,
      form: {
        layout: 'H5HorizontalNewsVideoList', // 展示方式
        dataSource: '', // 数据来源
        showDate: true, // 显示时间
        showTitle: true, // 显示栏目名称
        showMore: true, // 显示更多
        row: 1, // 展示行数
        col: 1, // 每行展示条数
        imageFit: 'fill', // 图片填充方式
        title: '', // 显示栏目名称
        isBorderRadius: false,
      },
      config: {
        component: h5NewsVideoType[0].value,
        w: 10,
        h: 10,
      },
      columnData: [],
      imageFitType,
    }
  },
  watch: {
    configData: {
      deep: true,
      immediate: true,
      handler(val) {
        if (!_.isEmpty(val)) {
          _.assign(this.form, val)
        } else {
          this.form = this.$options.data().form
          this.selectChange()
        }
      },
    },
    layoutData: {
      deep: true,
      immediate: true,
      handler(val) {
        if (!_.isEmpty(val)) {
          this.config = _.pick(this.layoutData, ['w', 'h', 'component', 'type', 'x', 'y', 'i'])
          this.config.isAdaptive = this.config.component === 'H5VerticalNewsVideoList'
        }
      },
    },
  },
  methods: {
    async getColumnData() {
      const [err, res] = await columnApi.tree(0)
      if (!err) {
        const data = treeToOneArray(res, 'child')
        this.columnData = _.filter(data, (item) => {
          return item.type === this.config.type
        })
      }
    },
    sourceChange() {
      this.form.title = _.find(this.columnData, { id: this.form.dataSource }).name
      this.selectChange()
    },
    selectChange() {
      this.$emit('configChange', this.form)
    },
    layoutChange(val) {
      this.config = _.cloneDeep(val)
      this.config.isAdaptive = this.config.component === 'H5VerticalNewsVideoList'
      this.$emit('layoutChange', val)
    },
  },
  created() {
    this.getColumnData()
  },
}
</script>

<style></style>
